<template>
<b-container fluid>
  <bo-page-title />

  <template v-if="isList">
    <b-tabs>
      <b-tab title="Page Settings">
        <b-card v-if="moduleRole('section_description')">
          <template #header>
            <h5 class="card-title">Section Description FAQ</h5>
          </template>
          <div class="d-flex align-items-center">
            <b-button variant="secondary" class="btn-rounded ml-auto" v-if="descriptionOpen" @click="setData('descriptionOpen', false)">
              Close <i class="fas fa-times ml-2"></i>
            </b-button>
            <b-button variant="outline-info" class="btn-rounded ml-auto" @click="setData('descriptionOpen', true)" v-else>
              Update Content <i class="fas fa-pencil-alt ml-2"></i>
            </b-button>

          </div>
          <hr />

          <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="descriptionOpen">
            <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
              <b-card class="border mb-0">
                <template #header>
                  <h5 class="card-title">Content</h5>
                </template>
                <b-row class="mb-2">
                  <b-col md=4>
                    <div class="form-group">
                      <label class="control-label">Title <span class="text-danger">*</span></label>
                      <b-form-input v-model="row.asc_title" />
                      <VValidate name="Title" v-model="row.asc_title" rules="required|min:3|max:160" />
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md=4>
                    <div class="form-group">
                      <label class="control-label">Description</label>
                      <b-form-textarea :rows="3" v-model="row.asc_content" />
                      <VValidate name="Description" v-model="row.asc_content" rules="min:3" />
                    </div>
                  </b-col>
                </b-row>
                <template #footer>
                  <div class="text-right">
                    <b-button variant="secondary" class="btn-rounded mr-3" @click="setData('descriptionOpen', false)">Cancel</b-button>
                    <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
                  </div>
                </template>
              </b-card>
            </b-form>
          </validation-observer>
          <div class="row justify-content-center" v-else>
            <div class="col-md-8 text-center">
              <h3>{{row.asc_title}}</h3>
              <div class="sect-heading__line"></div>
              <p>{{row.asc_content}}</p>
            </div>
          </div>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <b-row>
              <b-col lg="5">
                <h5 class="card-title">{{ pageTitle }} </h5>
              </b-col>
              <b-col lg="3">
                <b-form-group>
                  <v-select label="text" placeholder="Select Status" v-model="filter.status" :reduce="value => value.value" @input="doFilter()" :options="statusOptions" />
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <SearchInput :value.sync="filter.search" @search="doFilter" />
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="p-0">
            <b-table :fields="fields" :items="dataList||[]" :per-page="perPage" :primary-key="idKey" :busy="!dataList" responsive show-empty>
              <template #empty>
                <div class="text-center">
                  <b-img class="mb-2" width="90" fluid src="/assets/images/no-data.png" />
                  <h4 align="center"><span v-if="Object.keys(filter).length">No search results found</span><span v-else>No {{ pageTitle }} listed yet</span></h4>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(number)="v">
                {{(data.per_page*(data.current_page-1))+v.index+1}}
              </template>

              <template #cell(af_is_active)="data">
                <b-badge v-if="data.value=='Y'" variant="success">Active</b-badge>
                <b-badge v-else variant="danger">Inactive</b-badge>
              </template>
              <template #cell(action)="data">
                <b-button v-if="moduleRole('edit')" v-b-tooltip.hover title="Edit" class="btn-icon" variant="outline-primary" size="sm" :to="{name: $route.name, params: {pageSlug: data.item[idKey]}}">
                  <i class="ti-marker-alt"></i>
                </b-button>
                <b-button v-if="moduleRole('changeStatus')" v-b-tooltip.hover title="Change Status" class="btn-icon" variant="outline-info" size="sm" @click="doChangeStatus(data.index, data.item)">
                  <i class="ti-settings"></i>
                </b-button>
                <b-button v-if="moduleRole('delete')" v-b-tooltip.hover title="Delete" class="btn-icon" variant="outline-danger" size="sm" @click="doDelete(data.index, data.item)">
                  <i class="ti-trash"></i>
                </b-button>

              </template>
            </b-table>
          </b-card-body>
          <b-card-footer class="pagination-custom" v-if="(dataList||[]).length&&data.total>10">
            <b-pagination class="mb-0" v-model="pageNo" :per-page="data.per_page" :total-rows="data.total" />
          </b-card-footer>
        </b-card>
      </b-tab>

      <b-tab title="SEO Settings" v-if="moduleRole('seo')">
        <SEOSection />
      </b-tab>
    </b-tabs>
  </template>

  <template v-else>
    <Form :row.sync="row" v-bind="passToSub" />
  </template>
</b-container>
</template>

<script>
import GlobalVue from '@/libs/Global.vue'
import SEOSection from '@/components/SEOSection'
import Form from './Form.vue'
const _ = global._

export default {
  extends: GlobalVue,
  components: {
    Form, SEOSection
  },
  data() {
    return {
      idKey: 'af_id',
      statusKey: 'af_is_active',
      fields: [{
          key: 'number',
          label: '#'
        },
        {
          key: 'af_question',
          label: 'Question'
        },
        {
          key: 'afc_name',
          label: 'Category'
        },
        {
          key: 'af_is_active',
          label: 'Status'
        },
        {
          key: 'action'
        },
      ],

      row: {},
      mrCategory: [],
      descriptionOpen: false,
    }
  },
  computed: {
    passToSub() {
      return _.assign(this.passToSubComp || {})
    }
  },
  methods: {
    setData(key, value) {
      this.$set(this, key, value)
    },

    doSubmitDesc() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
              this.setData('descriptionOpen', false)
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
  },
  mounted() {
    this.apiGet()
  },
  watch: {
    $route() {
      this.apiGet()
    }
  }
}
</script>
